/* S-1, S-2 (lane SHEET_S, 2026-09-26): A DOOR STACKS OVER THE SHEET. A door opened from inside the sheet (a card's
   CHOOSE OPTIONS opens the page's one door #SvntyDoor, a quick-add modal hung outside this element) and every control of
   the sheet that removes itself on the click (the taste engine's Undo, Remove and Clear) never tears the sheet down: the
   outside tap is judged on the event's path as it was dispatched (a node its own handler removed is still inside), and a
   tap inside a door's layer belongs to that door. The door's close (ModalDialog.hide) removes the body lock without asking
   who else holds it: while this sheet is open it takes the lock back in the same task (the header's lock observer sees one
   steady state) and takes the focus trap back once the door has handed focus to its opener inside the sheet. Escape closes
   the topmost door only: the door's own keyup never reaches this element. */
var SVNTY_DOORS = 'quick-add-modal, modal-dialog, .svnty-door, [data-svnty-sort]';
var SVNTY_OPEN_DOORS = 'quick-add-modal[open], modal-dialog[open]';

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    const target = event.target;
    if (target.classList && target.classList.contains('modal-overlay')) return this.close(false);
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    if (path.indexOf(this) >= 0 || this.contains(target)) return;
    if (!target.isConnected) return;
    if (target.closest && target.closest(SVNTY_DOORS)) return;
    if (document.querySelector(SVNTY_OPEN_DOORS)) return;
    this.close(false);
  }

  onDoorClosed() {
    if (!this.isOpen()) return;
    document.body.classList.add('overflow-hidden');
    setTimeout(() => {
      if (!this.isOpen() || document.querySelector(SVNTY_OPEN_DOORS)) return;
      const active = document.activeElement;
      const inside = active && active !== document.body && this.detailsContainer.contains(active);
      trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'), inside ? active : this.detailsContainer.querySelector('[tabindex="-1"]'));
    }, 0);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.onDoorClosedEvent = this.onDoorClosedEvent || this.onDoorClosed.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.addEventListener('modalClosed', this.onDoorClosedEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.removeEventListener('modalClosed', this.onDoorClosedEvent);
    if (!document.querySelector(SVNTY_OPEN_DOORS)) document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
